import { IconMenu2 } from '@tabler/icons-react';
import { UserChip } from './UserChip.js';

export function TopBar({ onMenu }: { onMenu?: () => void }) {
  return (
    <header className="border-b border-line bg-white/70 backdrop-blur-md sticky top-0 z-30 pt-[env(safe-area-inset-top,0px)]">
      <div className="h-16 max-w-app mx-auto px-4 sm:px-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onMenu}
            aria-label="Open navigation"
            className="lg:hidden -ml-1 mr-1 flex h-11 w-11 items-center justify-center rounded-lg text-navy hover:bg-cream-deep/60 transition"
          >
            <IconMenu2 size={22} />
          </button>
          <div className="h-8 w-8 rounded-lg bg-navy flex items-center justify-center">
            <svg
              viewBox="0 0 100 112"
              className="h-5 w-auto"
              role="img"
              aria-label="Admitly"
            >
              <title>Admitly</title>
              <g transform="translate(0,6)">
                <path
                  d="M24 92 L24 46 A26 26 0 0 1 76 46 L76 92"
                  fill="none"
                  stroke="#FBF8F2"
                  strokeWidth="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M18 96 L82 96"
                  fill="none"
                  stroke="#FBF8F2"
                  strokeWidth="10"
                  strokeLinecap="round"
                />
                <path d="M42 14 L58 14 L53 30 L47 30 Z" fill="#C8A24B" />
              </g>
            </svg>
          </div>
          <div className="font-serif text-xl tracking-tighter2 text-ink">
            Admitly
          </div>
          <span className="badge bg-cream-deep text-navy hidden sm:inline-flex">
            Staging
          </span>
        </div>
        <UserChip />
      </div>
    </header>
  );
}
